import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { SEO_DATA, DEFAULT_SEO } from '../seo.config';
import { useAuth } from '../contexts/AuthContext';

export default function SEOManager() {
  const { pathname } = useLocation();
  const { currentArticle } = useAuth();

  let seo = SEO_DATA[pathname];
  let ogType = 'website';

  // Article de blog dynamique
  if (!seo && pathname.startsWith('/blog/') && currentArticle) {
    const imageUrl = currentArticle.cover?.url
      ? `https://blog.fastlineapp.com${currentArticle.cover.url}`
      : DEFAULT_SEO.image;

    seo = {
      title: `${currentArticle.title} – Fastline`,
      description:
        currentArticle.description ||
        `Lire l'article "${currentArticle.title}" sur Fastline.`,
      image: imageUrl,
    };

    ogType = 'article';
  }

  // Fallback
  if (!seo) seo = DEFAULT_SEO;

  const canonicalUrl = `https://fastlineapp.com${pathname}`;
  const image = seo.image || DEFAULT_SEO.image;

  return (
    <Helmet>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <meta name="robots" content="index,follow" />
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph */}
      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:url" content={canonicalUrl} />
      {image && <meta property="og:image" content={image} />}
      {image && <meta property="og:image:alt" content={seo.title} />}

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:description" content={seo.description} />
      {image && <meta name="twitter:image" content={image} />}
    </Helmet>
  );
}